<template>
  <div>
    <v-menu
      ref="dateMenu"
      v-model="dateMenu"
      :close-on-content-click="false"
      transition="scale-transition"
      offset-y
      min-width="290px"
    >
      <template v-slot:activator="{ on }">
        <v-text-field
          :value="dateFormatted"
          :label="label"
          filled
          outlined
          v-on="readonly && on"
          :hide-details="hideDetails"
          :dense="dense"
          v-mask="mask"
          :readonly="readonly"
          @change="change"
          :append-outer-icon="readonly ? '' : 'mdi-calendar'"
          @click:append-outer="dateMenu = true"
          placeholder="DD/MM/YY"
        ></v-text-field>
      </template>
      <v-date-picker
        ref="datePicker"
        :max="max"
        v-model="date"
        @input="dateMenu = false"
        first-day-of-week="1"
      ></v-date-picker>
    </v-menu>
  </div>
</template>

<script>
import moment, { min } from "moment";

export default {
  props: {
    value: String,
    label: String,
    hideDetails: {
      type: Boolean,
      default: true,
    },
    max: String,
    year: {
      type: Boolean,
      default: false,
    },
    dense: {
      type: Boolean,
      default: false,
    },
    startOf: {
      type: Boolean,
      default: false,
    },
    endOf: {
      type: Boolean,
      default: false,
    },
    readonly: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      dateMenu: false,
      date: this.value == null ? null : moment(this.value).format("YYYY-MM-DD"),
      mask: "##/##/##",
    };
  },
  watch: {
    dateMenu(val) {
      if (this.year) {
        val && setTimeout(() => (this.$refs.datePicker.activePicker = "YEAR"));
      }
    },
    date(val) {
      if (this.startOf) {
        this.$emit("input", moment(val).startOf("day").toISOString());
      } else if (this.endOf) {
        this.$emit("input", moment(val).endOf("day").toISOString());
      } else {
        this.$emit("input", moment(val).toISOString());
      }
    },
    value(val) {
      if (val) {
        this.date = moment(val).format("YYYY-MM-DD");
      }
    },
  },
  computed: {
    dateFormatted() {
      return this.value == null ? "" : moment(this.value).format("DD/MM/YY");
    },
  },
  methods: {
    change(val) {
      if (val) {
        this.date = moment(val, "DD/MM/YY").format("YYYY-MM-DD");
      }
    },
  },
};
</script>

<style>
</style>